import { api } from "@/redux/api";

import {
	CompanyToDoProgressInfoResponse,
	CompanyToDoProgressInfoResponseSchema,
} from "../../pages/ToDo/ToDoList/schema/to-do";

export const companyToDoProgressApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getCompanyToDos: builder.query<CompanyToDoProgressInfoResponse, void>({
			query: () => ({
				url: "to-do",
				responseSchema: CompanyToDoProgressInfoResponseSchema,
			}),
			providesTags: ["CompanyToDoProgress"],
		}),
	}),
});

export const { useGetCompanyToDosQuery } = companyToDoProgressApi;
export const companyToDoProgressReducer = companyToDoProgressApi.reducer;
export const companyToDoProgressMiddleware = companyToDoProgressApi.middleware;
